import styled from "styled-components";

export const DateAndTimePickerWrapper = styled.div`
  display: flex;
  gap: 10px;
`;
